import Button from '@/components/Button/index';
import Modal, { MEDIUM_MODAL_WIDTH } from "@/dsComponents/Modal";
import { ModalBody, ModalFooter, ModalFooterRight, ModalHeader, ModalTitle } from "@dextech-ai/dex-design-system";
import { InfoOutlined } from "@dextech-ai/dex-design-system/icons";
import rem from "@/utils/rem";
import { feature } from "@/utils/feature-verifier.js";
import { featureConstant } from "@/constants/configuration/feature.js";

const AgentPrincipalInformationModal = ({ visible, hide, show }) => {

	const modalHeaderText = feature(featureConstant.AGENT_PRINCIPAL_PHASE_2) ? "Enable Agent Principal" : "Enrolled as Agent to consume for Principal";
	const modalBodyText = feature(featureConstant.AGENT_PRINCIPAL_PHASE_2) ? "By enabling this function, you will be granted access to provide or consume data on behalf of organisations that have not yet joined the SGTraDex platform. You are required to provide the organization's company name and UEN for which you intend to provide or consume data on behalf." : "By enabling this function, you are allowed to consume data for company that is not onboarded to SGTraDex. You are required to provide the principal's company name and UEN. You can select the principal to initiate data request to the contributor.";

	return (
		<Modal width={MEDIUM_MODAL_WIDTH} visible={visible} close={hide}>
			<ModalHeader icon={<InfoOutlined data-ds-color="primary-dark" />}>
				<ModalTitle>{modalHeaderText}</ModalTitle>
			</ModalHeader>
			<ModalBody>
				<div className="eap-modal__content center">
					{modalBodyText}
				</div>
			</ModalBody>
			<ModalFooter>
				<ModalFooterRight>
					<Button full maxWidth="100" submit={() => hide()} text="Okay, got it!" />
				</ModalFooterRight>
			</ModalFooter>
		</Modal>
	)
}

export default AgentPrincipalInformationModal;
